export default "__VITE_ASSET__DDUQLjno__"